import styled from 'styled-components'
import { StyledMileageWarning as BaseMileageWarning } from '../ArbitrationForm.styled'

export const StyledArbitrationRequestSection = styled.div``

export const StyledMileageWarning = styled(BaseMileageWarning)``

export const StyledDocumentRequirement = styled.div``
